function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#f1f1f1}.cls-2{fill:#aaa}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_6620",
  d: "M14.456 0A14.456 14.456 0 1 1 0 14.456 14.456 14.456 0 0 1 14.456 0z",
  className: "cls-1",
  "data-name": "Path 6620"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Group_4256",
  "data-name": "Group 4256",
  transform: "translate(9.295 9.513)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_26_Copy_7",
  "data-name": "Group 26 Copy 7"
}, /*#__PURE__*/React.createElement("g", {
  id: "floppy-disk"
}, /*#__PURE__*/React.createElement("g", {
  id: "pencil",
  transform: "rotate(180 4.701 4.693)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M.418.4a1.475 1.475 0 0 1 2.023 0l.7.681-2.012 1.933-.711-.681a1.331 1.331 0 0 1 0-1.938z",
  className: "cls-2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape_Copy_2",
  d: "M6.532 4.609l.729 1.721a.786.786 0 0 1-1.078 1.009l-1.6-.807L0 1.945 1.932 0z",
  className: "cls-2",
  "data-name": "Shape Copy 2",
  transform: "rotate(180 3.663 3.713)"
})))));

function SvgEditmealdrawer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "close",
    width: 28.911,
    height: 28.911,
    viewBox: "0 0 28.911 28.911",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditmealdrawer);
export default __webpack_public_path__ + "static/media/editmealdrawer.a7fca82a.svg";
export { ForwardRef as ReactComponent };